import components from '../components';

export const instances = [];

export function loadComponents(context = document.documentElement) {
    if (!components || Object.keys(components).length === 0) {
        console.warn('App has no components');
        return;
    }

    return context.querySelectorAll('[data-component]').forEach((element) => {
        const instance = getInstanceByElement(element);

        if (instance) {
            console.warn('Error: instance exists: \n', instance);
            return true; // continue
        }

        let componentName = element.dataset.component;

        if (typeof components[componentName] === 'function') {
            const instance = createInstance(element, componentName, null)
        } else {
            console.warn(`Constructor for component "${componentName}" not found.`);
        }
    });
}

export function removeComponents(context = document.documentElement) {
    context.querySelectorAll('[data-component]').forEach(element => {
        const instance = getInstanceByElement(element);

        if (instance) {
            destroyInstance(instance);
        }
    });
}

export const getInstanceByElement = element => {
    let instance = null;
    instances.forEach(item => {
        if (item.element === element)  {
            instance = item;
        }
    });
    return instance;
}

export const getInstanceById = id => {
    let instance = null;
    instances.forEach(item => {
        if (item.id == id)  {
            instance = item;
        }
    });
    return instance;
}

export const createInstance = (element, componentName) => {
    // create instance
    let id = generateId();
    let instance = {};
    instance.id = id;
    instance.element = element;
    instance.componentName = componentName;
    instances.push(instance);

    // add component to instance (done after instance is create so it can be used in Component constructor)
    let component = new components[componentName](element);
    instance.component = component;
    instance.component.load();

    console.info(`Created instance of component "${componentName}" (${instance.id}).`);
    return instance;
}

export const destroyInstance = instance => {
    instance.component.destroy();

    // remove from instances
    let index = instances.indexOf(instance);
    if (index > -1) {
        instances.splice(index, 1);
    }
    console.info(`Removed component "${instance.component._name}" (${instance.id}).`);
}

const generateId = () => {
    let id;

    let unique = false;
    while(!unique) {
        id = generateString();
        unique = true;
        instances.forEach(item => {
            if (item.id == id) {
                unique = false;
            }
        })
    }

    return id;
}

const generateString = () => {
    let text = "";
    let possible = "abcdefghijklmnopqrstuvwxyz";

    for (let i = 0; i < 4; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
}

//window.instances = instances
//window.loadComponents = loadComponents
//window.removeComponents = removeComponents
//window.getInstanceById = getInstanceById
//window.getInstanceByElement = getInstanceByElement



// WEBPACK FOOTER //
// ./core/componentUtils.js